(() => {
  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function parseLocalDateTime(str) {
    // accetta "YYYY-MM-DD HH:MM" o "YYYY-MM-DDTHH:MM"
    const s = (str || "").trim().replace(" ", "T");
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function initCountdown(el) {
    // ✅ se esiste già un timer, lo spengo (evita doppio tick)
    if (el._countdownTimer) {
      clearInterval(el._countdownTimer);
      el._countdownTimer = null;
    }

    // ✅ inizializzato (utile se Shopify ricarica la section)
    el.dataset.initialized = "true";

    const endStr = el.getAttribute("data-countdown-end");
    const endDate = parseLocalDateTime(endStr);
    if (!endDate) return;

    const dd = el.querySelector("[data-dd]");
    const hh = el.querySelector("[data-hh]");
    const mm = el.querySelector("[data-mm]");
    const ss = el.querySelector("[data-ss]");

    if (!dd || !hh || !mm || !ss) return;

    function tick() {
      const now = new Date();
      const diffMs = Math.max(0, endDate - now);

      const totalSeconds = Math.floor(diffMs / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;

      // ✅ aggiorno solo il testo (non aggiungo nodi, quindi niente “doppio”)
      dd.textContent = pad(days);
      hh.textContent = pad(hours);
      mm.textContent = pad(mins);
      ss.textContent = pad(secs);

      if (diffMs <= 0) {
        el.classList.add("is-ended");
        clearInterval(el._countdownTimer);
        el._countdownTimer = null;
      }
    }

    tick();
    el._countdownTimer = setInterval(tick, 1000);
  }

  function initAll(root = document) {
    root.querySelectorAll("[js-countdown]").forEach(initCountdown);
  }

  document.addEventListener("DOMContentLoaded", () => initAll());

  // utile nel Theme Editor: quando Shopify ricarica la section
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();